import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyCDLtC3a08CkB2yO9DAgDYWMRntkmL9pmI",
  authDomain: "prugio-a83c7.firebaseapp.com",
  projectId: "prugio-a83c7",
  storageBucket: "prugio-a83c7.firebasestorage.app",
  messagingSenderId: "250380386223",
  appId: "1:250380386223:web:6a7ad2a03fff1ac7d6f95a",
  measurementId: "G-F602CBBHNZ"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Analytics (only in browser)
let analytics = null
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

// Initialize Firestore
const db = getFirestore(app)

// Initialize Auth
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

export { app, analytics, db, auth, googleProvider }
